export default __webpack_public_path__ + "static/media/favstar-yellow.3e069d6f.png";